export const compositePublishUrlParametersPrefix = "composite.";

export const compositePublishUrlParameters = [
  "signalingURL",
  "applicationName",
  "streamName",
  "audioBitrate",
  "audioCodec",
  "videoBitrate",
  "videoCodec"
]
export const layouts = [ // Video 1 Full
  { name: 'Video 1 Full', value: 0 },
  // Video 2 Full
  { name: 'Video 2 Full', value: 1 },
  // Video 1 Full, Video 2 PIP Top Right
  { name: 'Picture in Picture (Top Right)', value: 2 },
  // Video 2 Full, Video 1 PIP Top Right
  { name: 'Picture in Picture (Top Right)', value: 3 },
  // Video 1 Full, Video 2 PIP Top Left
  { name: 'Picture in Picture (Top Left)', value: 4 },
  // Video 1 Full, Video 2 PIP Bottom Left
  { name: 'Picture in Picture (Bottom Left)', value: 5 },
  // Video 1 Full, Video 2 PIP Bottom Right
  { name: 'Picture in Picture (Bottom Right)', value: 6 },
  // Side by Side
  { name: 'Side by Side', value: 7 }
];